import { render, staticRenderFns } from "./CountHeatmapChart.vue?vue&type=template&id=45a52e76&scoped=true&"
import script from "./CountHeatmapChart.vue?vue&type=script&lang=ts&"
export * from "./CountHeatmapChart.vue?vue&type=script&lang=ts&"
import style0 from "./CountHeatmapChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CountHeatmapChart.vue?vue&type=style&index=1&id=45a52e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a52e76",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
